import React, { useState, useEffect } from 'react';
import {Alert, Button, Table, Spinner, Modal, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import toastr from 'toastr';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';
import UserHeadDetail from '../../components/UserHeadDetail';
import UserHeadDetailMenu from '../../components/UserHeadDetailMenu';
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import { getAreas, getCarpetas, getSubNiveles, getDocs, saveDoc, editDoc } from '../../redux/gestorDocumental/actions';
import { getBase64 } from '../../components/gestorDocumental/GestorDocumental';
import LinkDescargaListGD from '../../components/gestorDocumental/LinkDescargaListGD';
import LinkDescargaGD from '../../components/gestorDocumental/LinkDescargaGD';
import config from '../../config';

const schema = Yup.object().shape({
  carpeta: Yup.string().required('**Campo requerido'),
  tipoDocumento: Yup.string().required('**Campo requerido'),
  descripcion: Yup.string().required('**Campo requerido'),
  archivo: Yup.mixed()
            .required('**Campo requerido')
            .test('fileSize', 
                  '**El archivo es demasiado grande, es requerido un archivo menor o igual a 200 megabytes',
                  value => value === null || (value && (value.size / 1024 < 200000)))
            /*.test('fileType', 
                  '**Tipo de archivo no soportado',
                   value => value === null || (value && ['image/jpg', 'image/png','application/pdf', 'text/csv'].includes(value.type)))*/,
  fechaEntrega: Yup.date().min(moment('1900-01-01')).required('**Campo requerido')
});

const Docs = props => {
  //* State
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [docs, setDocs] = useState([]);
  //const [validated, setValidated] = useState(false);
  //const [fileError, setFileError] = useState(false);
  //* Redux
  const dispatch = useDispatch();
  const data = useSelector(store => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(store => store.funcTabEmployeed.loadingFicha_Empleado);
  const {loadingDocs, 
         loadingAreas, 
         loadingCarpetas, 
         loaderSubNiveles, 
         saveDocsLoading,
         formErrors,
         error,
         areas, 
         carpetas,
         subNiveles,
         areasError,
         carpetasError,
         subNivelesError,
         docError} = useSelector(store => store.gestorDocumental);
  //const loadingDocs = useSelector(store => store.vaccinesEmp.loading);
  //const dataDocs = useSelector(store => store.vaccinesEmp.vacsEmp);
  //* variables
  const { otrosDocumentos, email } = config.gestorDocumental;
  //* Methods
  const filtersDocs = () => {
    return {
      id_empleado: props.match.params.id,
      tipo_documento: otrosDocumentos.tipoDocumento 
    }
  }

  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
    dispatch(getCarpetas());
    dispatch(getAreas());
    const _filtersDocs = filtersDocs();
    dispatch(getDocs(_filtersDocs, setDocs));
  }, []); //dispatch, props.match.params

  const onShowSidebar = () => setShow(show ? false : true);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    dispatch(getSubNiveles({
      areaid: item.id_area, 
      ceid: item.id_carpeta_encabezado, 
    }));
    //setLoadingType('modal');
    //setValidated(false);
  }

  const onGetSubNivelesList = e => {
    dispatch(getSubNiveles({
      areaid: areas[0].id, 
      ceid: parseInt(e.target.value), 
    }));
  }

  const handleClose = () => setShowModal(false);

  const onSubmit = async values => {
    /*console.log(values);
     e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    } */
    try {
      const filebase64 = await getBase64(values.archivo);
      const fileName = values.archivo.name;
      const fName = String(fileName).substring(0, String(fileName).lastIndexOf('.')).replace(/\W/g, '');
      const fExt = `.${String(fileName).substr( (fileName.lastIndexOf(".")+1 - fileName.length) )}`;
      const aFileBase = String(filebase64).split(',');
      const req = {
        id_area:  areas[0].id,
        id_carpeta_encabezado: parseInt(values.carpeta),
        empresa: data.empresa[0],
        zona: data.Division_Personal_List[0].descripcion,
        tipo_documento_GD: values.tipoDocumento,
        descripcion: values.descripcion, 
        id_empleado: data.id,
        tipo_documento: otrosDocumentos.tipoDocumento,
        archivo: aFileBase[1],
        fecha: moment(values.fechaEntrega.value).format('YYYY-MM-DD'),
        origen: fName + fExt,
        extension: fExt,
        id_registro: 0,
        contentTypeGD: `${aFileBase[0]},`
      }

      const options = {
        docType: null,
        docsState: {
          docs: docs,
          setDocs: setDocs
        }
      };

      if(edit){
        dispatch(editDoc(req, editItem.id, index, options));
      }else{
        //const _filtersDocs = filtersDocs();
        dispatch(saveDoc(req, options));
      }
    } catch (error) {
      console.log(error);
      toastr.info('Error al subir archivo');
      return;
    }
}
  return(
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {
            loading || loadingDocs || loadingAreas || loadingCarpetas ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <>
                <UserHeadDetail data={data} type={props.match.params.type} />
                <div className="my-4">
                  <UserHeadDetailMenu id={props.match.params.id} type={props.match.params.type} />
                    <div className="mt-4 mb-3">
                      <div className="d-flex aling-items-center justify-content-between px-2">
                    <h5 className="font-weight-bold text-uppercase">documentos <Button variant="primary" size="sm" className="ml-3 rounded-pill" onClick={() => onAdd()}><i className="material-icons">add</i> Agregar documento</Button></h5>
                    <div>
                      <span className="text-muted mr-3">
                        <i className="material-icons">vpn_key</i> Código:{" "}
                        {data.codigo}
                      </span>
                      <span className="text-muted mr-3">
                        <i className="material-icons">timer</i> Antigüedad:{" "}
                        {parseInt(data.antiguedad_laboral) / 12 > 1
                          ? parseFloat(data.antiguedad_laboral) / 12 -
                            Math.floor(parseInt(data.antiguedad_laboral) / 12)
                            ? `${parseInt(
                                Math.floor(data.antiguedad_laboral) / 12
                              )} años ${Math.round(
                                (parseFloat(data.antiguedad_laboral) / 12 -
                                  Math.floor(
                                    parseInt(data.antiguedad_laboral) / 12
                                  )) *
                                  12
                              )} meses`
                            : `${parseInt(data.antiguedad_laboral) / 12} años`
                          : `${parseInt(data.antiguedad_laboral)} meses`}
                      </span>
                      <span className="text-muted">
                        <i className="material-icons">moving</i>{" "}
                        {data.Relacion_Laboral_List
                          ? data.Relacion_Laboral_List[0].descripcion
                          : "No ingresado aún"}
                      </span>
                    </div>
                  </div>
                    
                    <hr className="mb-3" />
                    <div className="mt-4 mb-4">
                      {
                        !!error || !!areasError || !!carpetasError ? (
                          <Alert variant="danger">
                            {
                              !!error && (
                                <p>{error}</p>
                              )
                            }
                            {
                              !!areasError && (
                                <p>{areasError}</p>
                              )
                            }
                            {
                              !!carpetasError && (
                                <p>{carpetasError}</p>
                              )
                            }
                            {
                              !!docError && (
                                <p>{docError}</p>
                              )
                            }
                          </Alert>
                        ) : null
                      }
                      {
                        docs.length > 0 ? (
                          <Table variant="dark">
                            <thead>
                              <tr>
                                <th scope="col">Área</th>
                                <th scope="col">Carpeta</th>
                                <th scope="col">Empresa</th>
                                <th scope="col">División personal</th>
                                <th scope="col">Tipo de documento</th>
                                <th scope="col">Descripción</th>
                                <th scope="col">Fecha</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                docs.map((item, ind) => (
                                  <tr key={item.id}>
                                    <td>{areas.find(area => area.id === item.id_area) ? areas.find(area => area.id === item.id_area).descripcion : ''}</td>
                                    <td>{carpetas.find(carpeta => carpeta.id === item.id_carpeta_encabezado) ? carpetas.find(carpeta => carpeta.id === item.id_carpeta_encabezado).descripcion : ''}</td>
                                    <td>{item.empresa}</td>
                                    <td>{item.zona}</td>
                                    <td>{item.tipo_documento_GD }</td>
                                    <td>{item.descripcion}</td>
                                    <td>{moment(item.fecha).format('DD/MM/YYYY')}</td>
                                    <td>
                                      <ButtonGroup>
                                        <Button
                                          size="sm"
                                          variant="link"
                                          type="button"
                                          onClick={() => onEdit(item, ind)}>
                                            <i className="material-icons">edit</i>
                                        </Button>
                                        <LinkDescargaListGD
                                          id={item.id} 
                                          filters={{email: email, id: item.id_documento, llave: item.llave}} 
                                          origen={item.origen}
                                          cType={item.contentTypeGD} />
                                      </ButtonGroup>
                                    </td>
                                  </tr>
                                ))
                              }
                            </tbody>
                          </Table>
                        ): (
                          <Alert variant="info">
                            <p>No hay registros aún.</p>
                          </Alert>
                        )
                      }
                    </div>
                   </div>
                </div>
              </>
            )
          }
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            carpeta: edit ? editItem.id_carpeta_encabezado : '',
            tipoDocumento: edit ? editItem.tipo_documento_GD: '',
            descripcion: edit ? editItem.descripcion : '',
            archivo: null,
            fechaEntrega: edit ? editItem.fecha : ''
          }}>
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              values,
              touched,
              isValid,
              errors
            }) => (
              <Form onSubmit={handleSubmit} noValidate>
                <Modal.Header closeButton>
                  <Modal.Title>{edit ? 'Editar documento' : 'Crear documento'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {
                    !!formErrors || !!subNivelesError ? (
                      <Alert variant="danger">
                        <p>
                          {
                            !!formErrors && formErrors
                          }
                          {
                            !!subNivelesError && subNivelesError
                          }
                        </p>
                      </Alert>
                    ) : null
                  }
                  <Form.Group controlId="carpeta">
                    <Row className="align-items-end">
                      <Col sm={ loadingCarpetas ? '11': '12' }>
                        <Form.Label className="ml-2">Carpeta</Form.Label>
                        <Form.Control
                          onChange={e => {handleChange(e);  onGetSubNivelesList(e);}}
                          as="select"
                          name="carpeta"
                          className="rounded-pill"
                          value={values.carpeta}
                          isInvalid={touched.carpeta && !!errors.carpeta}
                          >
                            <option className="text-muted" value="" selected disabled>Selecionar carpeta</option>
                            {
                              carpetas.map(carp => (
                                <option key={carp.id} value={carp.id}>{carp.descripcion}</option>
                              ))
                            }
                        </Form.Control>

                        <Form.Control.Feedback type="invalid" className='ml-2'>
                          {errors.carpeta}
                        </Form.Control.Feedback>
                      </Col>
                      {
                        loadingCarpetas && (
                          <Col sm="1">
                            <Spinner animation="border" size="sm" />
                          </Col>
                        )
                      }
                    </Row>
                  </Form.Group>
                  <Form.Group controlId="tipoDocumento">
                    <Row className="align-items-end">
                      <Col sm={ loaderSubNiveles ? '11': '12' }>
                        <Form.Label className="ml-2">Tipo de documento</Form.Label>
                        <Form.Control
                          disabled={loaderSubNiveles}
                          as="select"
                          name="tipoDocumento"
                          className="rounded-pill"
                          value={values.tipoDocumento}
                          onChange={handleChange}
                          isInvalid={touched.tipoDocumento && !!errors.tipoDocumento}
                          >
                            <option className="text-muted" value="" selected disabled>Selecionar tipo documento</option>
                            {
                              subNiveles ? subNiveles.subNivelTipoDocList.map(carp => (
                                <option key={carp.id} value={carp.descripcion}>{carp.descripcion}</option>
                              )) : null
                            }
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.tipoDocumento}
                        </Form.Control.Feedback>
                      </Col>
                      {
                        loaderSubNiveles && (
                          <Col sm="1">
                            <Spinner animation="border" size="sm" />
                          </Col>
                        )
                      }
                    </Row>
                  </Form.Group>
                  <Form.Group controlId="descripcion">
                    <Row className="align-items-end">
                      <Col sm={ loaderSubNiveles ? '11': '12' }>
                        <Form.Label className="ml-2">Descripción</Form.Label>
                        <Form.Control
                          disabled={loaderSubNiveles}
                          as="select"
                          name="descripcion"
                          className="rounded-pill"
                          value={values.descripcion}
                          onChange={handleChange}
                          isInvalid={touched.descripcion && !!errors.descripcion}
                          >
                            <option className="text-muted" value="" selected disabled>Selecionar descripción</option>
                            {
                              subNiveles ? subNiveles.subNivelDescripcionList.map(desc => (
                                <option key={desc.id} value={desc.descripcion}>{desc.descripcion}</option>
                              )) : null
                            }
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.descripcion}
                        </Form.Control.Feedback>
                      </Col>
                      {
                        loaderSubNiveles && (
                          <Col sm="1">
                            <Spinner animation="border" size="sm" />
                          </Col>
                        )
                      }
                    </Row>
                  </Form.Group>
                  <Form.Group>
                    <Form.File
                      accept="image/*,application/pdf,.xlsx,.xls,.csv,.doc,.docx"
                      className="mt-2 text-left position-relative"
                      required
                      name="archivo"
                      label="Archivo"
                      onChange={e => setFieldValue('archivo', e.currentTarget.files[0])}
                      isInvalid={touched.archivo && !!errors.archivo}
                      feedback={errors.archivo}
                      //feedbackTooltip
                    />
                    <Form.Control.Feedback type="invalid">
                     {/*  <ul className="list-unstyled">
                        <li>
                          **Es requerido un archivo de menor peso.
                        </li>
                        <li>
                          **Es requerido un archivo con formato pdf o imagen.
                        </li>
                      </ul> */}
                      {errors.archivo}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-2" id="fechaEntrega">
                    <Form.Label className="ml-2">Fecha de entrega</Form.Label>
                    <Form.Control
                      //disabled={edit}
                      className="rounded-pill" 
                      type="date"
                      name="fechaEntrega"
                      value={values.fechaEntrega}
                      onChange={handleChange}
                      isInvalid={touched.fechaEntrega && !!errors.fechaEntrega}></Form.Control>
                    <small className="form-text text-muted ml-2">
                      Fecha en la que obtuvo el documento
                    </small>
                    <Form.Control.Feedback type="invalid">
                      {errors.fechaEntrega}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {
                    edit && (
                      <>
                        <p className="ml-2 text-muted">Documento actual</p>
                        <LinkDescargaGD 
                          id={editItem.id} 
                          filters={{email: email, id: editItem.id_documento, llave: editItem.llave}} 
                          origen={editItem.origen}
                          cType={editItem.contentTypeGD} />
                      </>
                    )
                  }
                </Modal.Body>
                <Modal.Footer>
                  <Button 
                    className="rounded-pill"
                    variant="secondary" 
                    onClick={handleClose}>
                    Close
                  </Button>
                  <Button
                    className="rounded-pill" 
                    disabled={saveDocsLoading}  
                    variant="primary" 
                    type="submit">
                      {
                        saveDocsLoading && (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true" />
                        )
                      }
                      Guardar</Button>
                </Modal.Footer>
              </Form>
            )}
        </Formik>
      </Modal>
    </>
  )
}

export default Docs
